import { PathOptions } from "leaflet";

export const neoenergia_pe_unseat = (feature: any): PathOptions => {
  // Unidades Seccionadoras AT - Red circles to distinguish from MT units
  return {
    color: "#CC0000", // Red border
    weight: 1,
    opacity: 1,
    fillColor: "#FF4D4D", // Light red fill
    fillOpacity: 0.7,
  };
};
